import { Component, Inject, OnInit } from '@angular/core';
import { UIActiveDialogService } from '../../../../shared/services/ui-dialog.service';
import { IssueModel } from '../../model/issue.model';

@Component({
  selector: 'keyword-dialog',
  templateUrl:
    'console/app-js/modules/issue/components/issues-edit-modal/issues-edit-modal.component.html'
})
export class IssuesEditModalComponent implements OnInit {
  protected issueModel: IssueModel = new IssueModel();
  private issueName: string;
  constructor(
    private activeDialogService: UIActiveDialogService,
    @Inject('issueModel') issue: IssueModel
  ) {
    issue[0].keywords =
      issue[0].keywords === 'Not Set' ? [] : issue[0].keywords;
    this.issueModel = issue[0];
  }

  ngOnInit(): void {
    this.issueName = this.issueModel.name;
  }

  onCancel(): void {
    this.issueModel = null;
    this.activeDialogService.dismiss();
  }

  /**
   * save edited issue.
   */
  onSave(): void {
    this.issueModel.name = this.issueName;
    this.activeDialogService.close(this.issueModel);
  }
}
